export const PUBLIC_TRUST_CENTER_LEGACY = {
  HERO_BANNER: {
    TAGLINE: 'Asegura tu negocio y simplifica el cumplimiento con IA',
  },
  OVERVIEW: {
    PRIVATE_RESOURCES: {
      TITLE: 'Recursos Privados',
    },
    COMPLIANCE: {
      TITLE: 'Compliance',
    },
    CONTROLS: {
      TITLE: 'Controles',
      UPDATED_ON: (date: string) => `Actualizado ${date}`,
      VIEW_ALL: 'Ver todos los controles',
      MORE_COUNT: (count: number) => `+${count} más`,
    },
    RESOURCES: {
      TITLE: 'Recursos',
      VIEW_ALL: 'Ver todos los recursos',
    },
    SUBPROCESSORS: {
      TITLE: 'Subprocesadores',
      VIEW_ALL: (count: number) => `Ver los ${count} subprocesadores`,
      PUBLISHED_DATE: (date: string) => `Publicado ${date}`,
    },
  },
  CONTROLS: {
    TITLE: 'Controles',
    SEARCH_PLACEHOLDER: 'Buscar controles...',
  },
  RESOURCES: {
    TITLE: 'Recursos',
    SEARCH_PLACEHOLDER: 'Buscar recursos...',
    VIEW: 'Ver',
    PRIVATE_RESOURCES: {
      TITLE: 'Cumplimiento',
    },
    PUBLIC_RESOURCES: {
      TITLE: 'Recursos Públicos',
    },
  },
  ERROR: {
    SOMETHING_WENT_WRONG: '¡Oops! Algo salió mal',
    TITLE: 'Error al cargar los recursos públicos',
    DESCRIPTION: 'No pudimos cargar los recursos públicos. Esto puede ser temporal, por favor inténtalo de ' + 'nuevo.',
    RETRY: 'Intentar de nuevo',
    WRONG_EMAIL: 'Formato de email inválido',
  },
  SUBPROCESSORS: {
    TITLE: 'Subprocesadores',
    SEARCH_PLACEHOLDER: 'Buscar...',
  },
  TABS: {
    OVERVIEW: 'Resumen',
  },
  DIALOGS: {
    REQUEST_ACCESS: {
      TRIGGER_BUTTON: 'Solicitar Acceso',
      TITLE: 'Solicitar Acceso',
      DESCRIPTION: 'Rellene todos los campos para acceder a este recurso.',
      FORM: {
        FIRST_NAME: 'Nombre',
        LAST_NAME: 'Apellido',
        EMAIL: 'Correo Electrónico',
        COMPANY: 'Empresa',
      },
      BUTTONS: {
        CANCEL: 'Cancelar',
        SUBMIT: 'Solicitar Acceso',
      },
      SUCCESS_MESSAGE: 'Solicitud de acceso enviada correctamente',
    },
    REQUEST_SUCCESS: {
      TITLE: 'Solicitud de Acceso de Seguridad Registrada',
      DESCRIPTION: 'Su solicitud de acceso ha sido registrada para revisión',
      REQUEST_ID_LABEL: 'ID DE SOLICITUD',
      NAME_LABEL: 'Nombre:',
      EMAIL_LABEL: 'Correo:',
      COMPANY_LABEL: 'Empresa:',
      RESOURCE_LABEL: 'Recurso:',
      PROCESS_MESSAGE: 'El acceso será aprovisionado tras la aprobación de seguridad exitosa.',
      BUTTON: 'Confirmar',
    },
  },
} as const
